export const FETCHING_USER = 'FETCHING_USER';
export const DELETING_ACCOUNT = 'DELETING_ACCOUNT';
export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_PICTURE = 'UPDATE_PICTURE';
export const UPDATE_PASSWORD = 'UPDATE_PASSWORD';
export const FETCH_APPLICATIONS = 'FETCH_APPLICATIONS';